export const __wrapper = ({
	theme,
	flex = false,
	unsetMargin,
	unsetMarginSide,
	disabled,
}) => ({
	marginTop: theme.spaces['32'],
	display: flex ? 'flex' : 'block',
	position: 'relative',
	alignItems: 'center',
	height: 40,
	marginLeft: 32,
	marginRight: 32,
	touchAction: 'pan-y',
	extend: [
		{
			condition: unsetMargin,
			style: {
				marginTop: 0,
				marginLeft: 11,
				marginRight: 11,
			},
		},
		{
			condition: unsetMarginSide,
			style: {
				marginLeft: 11,
				marginRight: 11,
			},
		},
		{
			condition: disabled,
			style: {
				touchAction: 'none',
			},
		},
	],
})

export const __track = ({ disabled }) => ({
	height: 4,
	position: 'absolute',
	top: '50%',
	transform: 'translateY(-50%)',
	width: '100%',
	cursor: 'pointer',
	extend: [
		{
			condition: disabled,
			style: {
				cursor: 'default',
				pointerEvents: 'none',
			},
		},
	],
})

export const __baseTrack = ({ theme }) => ({
	width: '100%',
	height: 4,
	display: 'flex',
	backgroundColor: theme.colors.lightGrey2,
	position: 'absolute',
	left: 0,
	top: 0,
	borderRadius: 2,
})

export const __highlightedTrack = ({ theme, disabled }) => ({
	width: '100%',
	height: 4,
	position: 'absolute',
	top: 0,
	zIndex: 1,
	backgroundColor: theme.primary(theme).backgroundColor,
	borderRadius: 2,
	transformOrigin: 'left center',
	extend: [
		{
			condition: disabled,
			style: {
				backgroundColor: theme.colors.redTwoMuted,
			},
		},
	],
})

export const __sliderThumb = ({ disabled }) => ({
	display: 'flex',
	height: 40,
	width: 40,
	left: -20,
	outline: 'none',
	position: 'absolute',
	userSelect: 'none',
	backgroundColor: 'transparent',
	border: 'none',
	padding: 0,
	cursor: 'pointer',

	':hover .indicator': {
		transform: 'scale(1)',
	},
	':active .indicator': {
		transform: 'scale(1)',
	},
	':focus .indicator': {
		transform: 'scale(1)',
	},

	':hover > .knob': {
		boxShadow:
			'0px 0.8px 4.8px rgb(0 0 0 / 10%), 0px 3.2px 6.4px rgb(0 0 0 / 15%), 0 0 0 9px #ffe8eb',
	},
	':active > .knob': {
		boxShadow:
			'0px 0.8px 4.8px rgb(0 0 0 / 10%), 0px 3.2px 6.4px rgb(0 0 0 / 15%), 0 0 0 9px #ffe8eb',
	},
	':focus > .knob': {
		boxShadow:
			'0px 0.8px 4.8px rgb(0 0 0 / 10%), 0px 3.2px 6.4px rgb(0 0 0 / 15%), 0 0 0 9px #ffe8eb',
	},

	extend: [
		{
			condition: disabled,
			style: {
				cursor: 'default',
				pointerEvents: 'none',
			},
		},
	],
})

export const __sliderKnob = ({ theme, disabled }) => ({
	width: 22,
	height: 22,
	position: 'absolute',
	top: '50%',
	left: '50%',
	border: `1px solid ${theme.primary(theme).backgroundColor}`,
	boxSizing: 'border-box',
	boxShadow:
		'0px 0.8px 4.8px rgba(0, 0, 0, 0.1), 0px 3.2px 6.4px rgba(0, 0, 0, 0.15)',
	borderRadius: 11,
	backgroundColor: theme.primary(theme).colorWhite,
	transform: 'translate(-50%, -50%)',
	cursor: 'pointer',
	outline: 'none',

	extend: [
		{
			condition: disabled,
			style: {
				cursor: 'default',
				pointerEvents: 'none',
				borderColor: theme.colors.redTwoMuted,
			},
		},
	],
})

export const __valueIndicatorWrapper = () => ({
	bottom: 36,
	left: '50%',
	pointerEvents: 'none',
	position: 'absolute',
	transform: 'translateX(-50%)',
})

export const __valueIndicator = () => ({
	backgroundColor: 'black',
	transition: 'transform 100ms 0ms cubic-bezier(0.4, 0, 1, 1)',
	alignItems: 'center',
	borderRadius: 2,
	display: 'flex',
	height: 32,
	padding: '4px 14px',
	transform: 'scale(0)',
	transformOrigin: 'bottom',

	':before': {
		borderLeft: '6px solid transparent',
		borderRight: '6px solid transparent',
		borderTop: '6px solid',
		borderTopColor: 'black',
		content: '""',
		height: 0,
		width: 0,
		position: 'absolute',
		left: '50%',
		bottom: -5,
		transform: 'translateX(-50%)',
	},
})

export const __valueIndicatorText = ({ theme }) => ({
	color: theme.primary(theme).colorWhite,
})
